var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 53.5,
    r: 53.5,
    fill: "#FFDAE7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.6386 36.5815C74.6855 33.8598 72.0111 31.1855 69.2895 32.2323L31.1575 46.8985C28.1086 48.0712 28.35 52.4628 31.5091 53.294L47.2385 57.4334C47.8252 57.5878 48.2831 58.0459 48.4374 58.6324L52.5768 74.3619C53.4081 77.5208 57.7999 77.7625 58.9724 74.7135L73.6386 36.5815Z",
    fill: "#EA4DA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareButton);
export default __webpack_public_path__ + "static/media/ShareButton.28d69dcaef258d7ad1d2ad251e570c9b.svg";
export { ForwardRef as ReactComponent };